import React from "react";
import { styled } from "@mui/material/styles";
import { Typography, Box, FormControlLabel, Button, FormControl, Grid, Checkbox, Tooltip, TableCell, Paper } from "@mui/material";
import TextField from '@mui/material/TextField';
import ListItemText from '@mui/material/ListItemText';

import { IconStyleProps } from "./Types";
import Switch from '@mui/material/Switch';

export const BoxRight = styled(Box)({
  display: "flex",
  justifyContent: "right"
})

export const GridCenter = styled(Grid)({
  display: "flex",
  justifyContent: "center"
})

export const BoxMainFilter = styled(Box)({
  flex: "60%",
});

export const BoxMainFilterActive = styled(Box)(({ theme }) => ({
  flex: "40%",
  backgroundColor: theme.palette.secondary.main,
  padding: "10px 15px 10px 15px",
  display: "flex",
  flexDirection: "column",
  minHeight: "400px"
}));

export const BoxMainFilterActiveOther = styled(Box)(({ theme }) => ({
  flex: "40%",
  backgroundColor: theme.palette.secondary.main,
  padding: "10px 15px 10px 15px",
  display: "flex",
  flexDirection: "column",
  minHeight: "130px"
}));

export const BoxPopulation = styled(Grid)(({ theme }) => ({
  flex: "40%",
  backgroundColor: theme.palette.secondary.main,
  padding: "10px 15px 10px 15px",
  display: "flex",
  flexDirection: "column",
  minHeight: "130px"
}));

export const BoxJourney = styled(Box)(({ theme }) => ({
  // flex: "40%",
  backgroundColor: theme.palette.secondary.main,
  padding: "10px 15px 10px 15px",
  // display: "flex",
  // flexDirection: "column",
  minHeight: "130px"
}));

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  flexGrow: 1,
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.text.primary,
    },
  },
  "& .MuiInputBase-root": {
    "&:focus": {
      color: theme.palette.text.primary,
    },
    "&.Mui-focused": {
      color: theme.palette.text.primary,
    },
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: theme.palette.grey[300],
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.grey[300],
    },
  }
}))

export const BaseListItemStyles = () => {
  return {
    backgroundColor: "inherit",
    border: "none",
    cursor: "pointer",
    
  };
};

export const ListItems = styled("li")(() => ({
  ...BaseListItemStyles(),
  padding: "4px 0px 4px 0px",
}));

export const ListItemAll = styled("li")(() => ({
  ...BaseListItemStyles(),
  padding: "6px 0px 6px 0px",
}));

export const ListItemsModal = styled("li")(() => ({
  ...BaseListItemStyles(),
  padding: "0px 0px 0px 0px",
}));

export const ListItemsPopulation = styled("li")(({ theme }) => ({
  ...BaseListItemStyles(),
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.secondary.main,
}));

export const Txt = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  fontSize: "25px",
  paddingBottom: "15px"
}));

export const TxtSub = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  fontSize: "25px",
  paddingTop: "20px",
  borderBottom: "1px solid"

}));

export const TxtFilter = styled(Typography)({
  fontSize: "25px",
});

export const TxtFilterToo = styled(Typography)({
  fontSize: "20px",
  fontWeight: 800,
  color: "white"
});

export const TxtFilterItalic = styled(Typography)({
  fontSize: "15px", 
  textDecoration: "italic"
});

export const TxtFilterSub = styled(Typography)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    fontSize: "15px",
    paddingTop: "15px"
  }));

  export const TxtFilterReUp = styled(Typography)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    fontSize: "15px",
    paddingTop: "5px"
  }));

export const BoxTypography = styled(Typography)({
  backgroundImage:
    "linear-gradient(rgb(63, 97, 129), rgb(119, 154, 186))",
  fontSize: "18px",
  padding: "2px 5px 2px 5px",
  borderRadius: "5px",
  display: "inline-block",
  margin: "4px"
});

export const DashboardNextButton = styled(Button)({
  fontSize: "15px",
  marginTop: '17px',
  marginRight: "17px",
})

export const BoxTypographySmaller = styled(Typography)({
  backgroundImage:
    "linear-gradient(rgb(63, 97, 129), rgb(119, 154, 186))",
  fontSize: "18px",
  padding: "2px 5px 2px 5px",
  borderRadius: "5px",
  display: "inline-block",
  margin: "4px",
  color: "white"
});

export const BoxFilters = styled(Typography)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  paddingTop: "15px",
  overflowY: "auto",
  color: "white"
}));

export const FilterButtonsBox = styled(Box)({
  padding: "10px 0px 16px 0px",
  display: "flex",
  flexDirection: "row",
});

export const BoxCentered = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});

export const BoxDropdown = styled(Box)({
    cursor: "pointer",
    border: "1px solid #3F6181",
    borderRadius: "10px",
    padding: "16px 16px 16px 16px",
    backgroundImage:
    "linear-gradient(rgb(63, 97, 129), rgb(119, 154, 186))",
})

export const BoxCenteredGap = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px"
});

export const ClearFiltersButton = styled("span")({
  marginTop: "auto",
  backgroundImage:
    "linear-gradient(rgb(63, 97, 129), rgb(119, 154, 186))",
  color: "white",
  borderRadius: "10px",
  padding: "8px 16px",
  cursor: "pointer",
  fontSize: "13px",
  marginLeft: "10px",
  display: "inline-flex",
  alignItems: "center",
});

export const ListHover = styled("span")(({ theme }) => ({
  fontSize: "13px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      padding: "10px 5px 10px 5px",
      borderRadius: "10px",
    },

}));

export const DashboardLabelTxt = styled("label")({
      color: "white",
      fontWeight: 600,
      minWidth: 70,
      textAlign: "right",
      paddingRight: "20px",
      fontSize: "1rem",
})
export const LabelTxt = styled("label")({
    fontSize: "18px",
});

export const LabelTxtTwo = styled("label")({
    fontSize: "16px",
    fontStyle: "italic",
});

export const LabelTxtThree = styled("label")({
    fontSize: "15px",
});

export const BoxDVC = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'end',
  marginRight: '50px',
  marginTop: '30px'
}));

export const DatePickerModal = styled(Typography)({
  fontSize: "18px",
});

export const DatePickerText = styled(Typography)({
  fontSize: "15px",
});

export const StyledFormContFilter = styled(FormControl)(({ theme }) => ({
    margin: 1,
    minWidth: 200,
    backgroundColor: theme.palette.secondary.main
}));

export const StyledFormContDatePicker = styled(FormControl)(({ theme }) => ({
    width: "90%",
    height: "75%",
    backgroundColor: theme.palette.secondary.main,
}));

export const SubcategoryContainer = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
});


export const ButtonDays = styled(Button)({
  backgroundColor: "#3F6181",
  color: 'white',
  fontSize: "10px",
  width: "20px",
  height: "35px",
  minWidth: "40px",
  borderRadius: "90%",
  marginLeft: "5px",
  "&:hover": {
    backgroundColor: "#555555",
  },
})

export const TextBolded = styled(Typography)({
  color: "#3f6181",
  fontSize: "20px",
  fontWeight: 800
})

export const DVCDashboardCardHeader = styled(Typography)(() => {
  return {
    color: "#3f6181",
    fontSize: "20px",
    fontWeight: 800
  }
})

export const TextBoldedBlue = styled(Typography)({
  fontSize: "20px",
  fontWeight: 800
})

export const DVCTableCell = styled(TableCell)({
  fontSize: "15px",
});

export const DVCDashboardCardBox = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center"
}));

export const DVCCustomBox = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "15px",
  display: "flex",
  // flexDirection: "column",
  paddingTop: "15px",
  justifyContent: "center",
  // alignItems: "center"
}));

export const DVCCustomBoxBlue = styled(Grid)(({ theme }) => ({
  backgroundColor: "#3f6181",
  borderRadius: "15px",
  display: "flex",
  paddingTop: "15px",
  // flexDirection: "column",
  justifyContent: "center",
  // alignItems: "center"
}));

export const DVCDashboardCardBoxWhite = styled(DVCDashboardCardBox)(({ theme }) => ({
  backgroundColor: "white",
}));

export const DVCDashboardCardBoxBlue = styled(Grid)({
  backgroundColor: "#3f6181",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const DVCDataBox = styled(Box)({
  marginLeft: "5px",
  mt: 1,
  display: "flex",
  flexDirection: "row",
})


export const DVCDashboardCardHeaderBlue = styled(Typography)({
  color: "white",
  fontSize: "20px",
  fontWeight: 800
})

export const DVCDashboardCardHeaderBlueSmaller = styled(Typography)({
  color: "white",
  fontSize: "10px",
  fontWeight: 600
})

export const DVCDashboardItemsList = styled(Typography)({
  fontSize: "15px",
  fontWeight: 700,
})

export const DVCDashboardContentsBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  paddingBottom: "10px",
})

export const DVCKeyLabel = styled(Typography)({
  fontSize: "12px",
})

export const ListItemTextStyled = styled(ListItemText)(() => {
  return {
    fontSize: "10px",
    "&& .MuiTypography-root": {

      fontSize: "15px",
      color: "",
    },
  };
});

export const FormControlSmallCheckbox = styled(Checkbox)({
  "&& .MuiSvgIcon-root": {
    width: "15px",
    height: "15px",
  },
});

export const TooltipToe = styled(Tooltip)({
  padding: "none"
})

export const TooltipOneClickBox = styled(Box)({
  marginRight: "20px",
  paddingTop: "10px"
})

export const IconStyle = styled(({ IconComponent, ...props }: IconStyleProps) => <IconComponent {...props} />)({
  paddingRight: '8px',
  color: 'white'
});

export const IconStyleBlue = styled(({ IconComponent, ...props }: IconStyleProps) => <IconComponent {...props} />)({
  paddingRight: '8px',
  color: '#3f6181'
});


export const ErrorText = styled(Typography)({
  fontSize: "10px",
  color: "red",
  marginTop: "7px",
})

export const ToggleButton = styled('button')({
backgroundColor: "inherit",
border: "none",
cursor: "pointer",
})

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "rgba(63, 97, 129, 0.08)", 
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#3f6181", 
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#ffffff", 
  },
  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#3f6181", 
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#ccc", 
  },
}));

export const TableauChevron = styled(Box)({
  display: "flex", 
  alignItems: "center", 
  justifyContent: "center", 
  flexShrink: 0, 
  marginRight: "10px"
})

export const TableauPaper = styled(Paper)({
  borderRadius: 4,
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
  backgroundColor: "background.paper",
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
});

export const TableauBox = styled(Box)({
  padding: "20px 0px 20px 20px",
  borderBottom: "1px solid",
  borderColor: "divider",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})